import { render, staticRenderFns } from "./aside-archive-svg.vue?vue&type=template&id=173abd8c&scoped=true"
import script from "./aside-archive-svg.vue?vue&type=script&lang=js"
export * from "./aside-archive-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173abd8c",
  null
  
)

export default component.exports